import { logout } from "../api";

/**
 * Full-lockdown (tier-2 maintenance) screen. When an operator has locked the platform down, the auth hook
 * 503s every non-operator request; `getMe` reports `"maintenance"` and the app shows this instead of the
 * dashboard. Operators are never sent here (they pass the hook and use the app normally, e.g. to lift the
 * lockdown). One neutral notice + a way to sign out; a reload retries once the lockdown is lifted.
 */
export function Maintenance() {
  return (
    <div className="gate">
      <div className="gate-card alert" role="alert">
        <div className="brand big">Amendie</div>
        <h2 className="gate-title">Down for maintenance</h2>
        <p className="muted">
          Amendie is temporarily unavailable while we perform maintenance. Your account and data are
          safe — please check back shortly.
        </p>
        <div className="row-gap" style={{ justifyContent: "center", marginTop: "var(--sp4)" }}>
          <button className="btn lg" onClick={() => window.location.reload()}>
            Try again
          </button>
          <button className="btn ghost lg" onClick={() => void logout().then(() => (window.location.href = "/"))}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
